import { store } from '@app/state/store';
import {
  CoreRootState,
  getSettingsVersionCore,
} from '@westondev/tableturn-core';

export const getSettingsVersion = () =>
  getSettingsVersionCore(store.getState() as CoreRootState);
